namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class PerDayCampaign extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);

            this.isAutoComplete
        }

        numberFormat(value) {

            var input = $(`<input type="text">`); var optionAuto =
            $.cookie("formatnumber");
            if (optionAuto == undefined) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }

            input.autoNumeric('set', value);
            return input.val();
        }

        isAutoComplete() {
            return true;
        }

        getLookup() {
            var oke = {} as Q.Lookup<object>;
            oke.items = [
                { id: "0", text: "All" },
                { id: "100", text: "100 Per Account" },
                { id: "200", text: "200 Per Account" },
                { id: "300", text: "300 Per Account" },
                { id: "400", text: "400 Per Account" },
                { id: "500", text: "500 Per Account" },
                { id: "600", text: "600 Per Account" },
                { id: "700", text: "700 Per Account" },
                { id: "800", text: "800 Per Account" },
                { id: "900", text: "900 Per Account" },
                { id: "1000", text: `${this.numberFormat(1000)} Per Account` },
                { id: "2000", text: `${this.numberFormat(2000)} Per Account` },
                { id: "3000", text: `${this.numberFormat(3000)} Per Account` },
                { id: "4000", text: `${this.numberFormat(4000)} Per Account` },
                { id: "5000", text: `${this.numberFormat(5000)} Per Account` },
            ]
            oke.idField = "id";
            oke.textField = "text";
            oke.itemById = {
                0: {
                    id: "0", text: "All"
                },
                100: { id: "100", text: "100 Per Account" },
                200: { id: "200", text: "200 Per Account" },
                300: { id: "300", text: "300 Per Account" },
                400: { id: "400", text: "400 Per Account" },
                500: { id: "500", text: "500 Per Account" },
                600: { id: "600", text: "600 Per Account" },
                700: { id: "700", text: "700 Per Account" },
                800: { id: "800", text: "800 Per Account" },
                900: { id: "900", text: "900 Per Account" },
                1000: { id: "1000", text: `${this.numberFormat(1000)} Per Account` },
                2000: { id: "2000", text: `${this.numberFormat(2000)} Per Account` },
                3000: { id: "3000", text: `${this.numberFormat(3000)} Per Account` },
                4000: { id: "4000", text: `${this.numberFormat(4000)} Per Account` },
                5000: { id: "5000", text: `${this.numberFormat(5000)} Per Account` },
            }
            return oke;
        }
        getTextField() {
            return "text";
        }

        protected getItems(lookup: Q.Lookup<object>) {
            return this.filterItems(this.cascadeItems(lookup.items));
        }

        getIdField() {
            return "id";
        }

        protected asyncSearch(query: Serenity.Select2SearchQuery, results: (result: Serenity.Select2SearchResult<object>) => void): Serenity.Select2SearchPromise {
            return this.getLookupAsync().then(lookup => {
                this.lookup = lookup;
                var items = this.getItems(this.lookup);

                if (query.idList != null) {
                    items = items.filter(x => query.idList.indexOf(this.itemId(x)) >= 0);
                }

                function getText(item: object) {
                    return this.getItemText(item, this.lookup);
                }

                items = Serenity.Select2Editor.filterByText(items, getText.bind(this), query.searchTerm);

                results({
                    items: items.slice(query.skip, query.take),
                    more: items.length >= query.take
                });
            }) as any;
        }

        getCreateSearchChoice(getName: (z: any) => string) {
            var $this = this;
            return function (getName) {
                if (isNaN(getName)) {
                    return { id: "0", text: "All" }
                } else {
                    if (getName.length > 8) {
                        return { id: "0", text: "All" }
                    } else {
                        return { id: `${getName}`, text: `${$this.numberFormat(getName)} Per Account` }
                    }
                }
            };
;
        }
    }
}